import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import Button from "../../../componentes/button/button";
import DropDown from "../../../componentes/dropdown/dropdown";
import Input from "../../../componentes/input/input";

import AjusteComissaoService from "../../../services/resource/AjusteComissaoService";
import Textarea from "../../../componentes/input/textarea";
import FilialService from "../../../services/resource/filialService";
import { ANOS, MESES } from "../../../utils/options";

function CadastrarAjusteComissao({
    ano,
    mes,
    onClose,
    onSuccess,
    transportes = [],
    defaultValues = {},
    showFilial = true,
    showTransporte = true,
    camposDesabilitados = []
}) {

    const initialValues = {
        filialId: null,
        transporte: "",
        tipo: null,
        motivo: "",
        isDl: null,
        ano: ano || null,
        mes: mes || null
    };

    const ajusteService = new AjusteComissaoService();
    const filialService = new FilialService();

    const [form, setForm] = useState({ ...initialValues, ...defaultValues });

    const [loading, setLoading] = useState(false);
    const [erros, setErros] = useState(false);
    const [filiais, setFiliais] = useState([]);
    const [filial, setFilial] = useState();
    const [tipos, setTipos] = useState([]);

    useEffect(() => {
        document.title = "MyDash | Ajuste de Comissão";

        filialService.listar().then(res => setFiliais(res.data));
    }, []);

    useEffect(() => {
        const filialEncontrada = filiais.find(f => f.id === form.filialId);
        setFilial(filialEncontrada);

        if (filialEncontrada?.tipoDistribuidor === "LOGISTICO") {
            setTipos([
                { label: "Ignorar Conclusão Greenmile", value: "IGNORAR_GREENMILE" },
                { label: "Ignorar Retorno", value: "IGNORAR_RETORNO" },
                { label: "Ignorar Cubagem", value: "IGNORAR_CUBAGEM" },
                { label: "Ignorar Telemetria", value: "IGNORAR_TELEMETRIA" },
            ])
        } else {
            setTipos([
                { label: "Ignorar Data de Acerto", value: "IGNORAR_ROMANEIO_ACERTO" },
                { label: "Ignorar Retorno de Romaneio", value: "IGNORAR_ROMANEIO_RETORNO" },
            ]);
        }

        setCampo("isDl", filialEncontrada?.tipoDistribuidor === "LOGISTICO" ? true : false)

    }, [form.filialId, filiais])

    const setCampo = (campo, valor) => {
        setForm(prev => ({
            ...prev,
            [campo]: valor
        }));
    };

    const validar = () => {

        if (!form.tipo) return false;
        if (!form.motivo) return false;

        if (showFilial && !form.filialId) return false;

        return true;
    };

    const handleSalvar = async () => {

        setErros(true);

        if (!validar()) {
            toast.error("Preencha os campos obrigatórios.");
            return;
        }

        setLoading(true);

        try {

            const response = await ajusteService.solicitar(form);

            toast.success("Ajuste solicitado com sucesso!");

            if (onSuccess) {
                onSuccess(response.data);
            }

            if (onClose) {
                onClose();
            }

        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    
    return (

        <div className="flex flex-col gap-5 pt-4 w-full space-y-">

            <div className="px-1 grid grid-cols-2 md:grid-cols-4 gap-3">
                <DropDown
                    label="Ano"
                    required
                    filter={false}
                    optionLabel="label"
                    optionValue="value"
                    options={ANOS}
                    value={form.ano}
                    onChange={e => setCampo("ano", e.value)}
                    error={form.ano === null && erros}
                    touched={erros}
                    disabled={camposDesabilitados.includes("ano")}
                />

                <DropDown
                    label="Mês"
                    required
                    filter={false}
                    optionLabel="label"
                    optionValue="value"
                    options={MESES}
                    value={form.mes}
                    onChange={e => setCampo("mes", e.value)}
                    error={form.mes === null && erros}
                    touched={erros}
                    disabled={camposDesabilitados.includes("mes")}
                />

            </div>

            <div className="px-1 grid grid-cols-2 md:grid-cols-3 gap-3">
                {showFilial && (

                    <DropDown
                        label="Filial"
                        required
                        filter={false}
                        optionLabel="nome"
                        optionValue="id"
                        options={filiais}
                        value={form.filialId}
                        onChange={e => setCampo("filialId", e.value)}
                        error={form.filialId === null && erros}
                        touched={erros}
                        disabled={camposDesabilitados.includes("filialId")}
                    />

                )}

                {showTransporte && (

                    <Input
                        label={`${filial?.tipoDistribuidor === "LOGISTICO" ? "Transporte" : "Romaneio Completo"}`}
                        value={form.transporte}
                        placeholder="Ex: 6648-20260226004"
                        onChange={e => setCampo("transporte", e.target.value)}
                        disabled={form.filialId === null || camposDesabilitados.includes("transporte")}
                    />

                )}

                <DropDown
                    label="Tipo de Ajuste"
                    required
                    optionLabel="label"
                    optionValue="value"
                    options={tipos}
                    filter={false}
                    value={form.tipo}
                    onChange={e => setCampo("tipo", e.value)}
                    error={form.tipo === null && erros}
                    touched={erros}
                    disabled={form.filialId === null}

                />

                <div className="md:col-span-3">

                    <Textarea
                        label="Motivo do Ajuste"
                        value={form.motivo}
                        onChange={e => setCampo("motivo", e.target.value)}
                        error={!form.motivo && erros}
                        touched={erros}
                        disabled={form.filialId === null}
                    />

                </div>

            </div>

            <div className="flex justify-end border-t border-border items-end">

                <div className="flex justify-end gap-3 items-end pt-3">

                    <Button
                        label="Cancelar"
                        variant="gray"
                        onClick={onClose}
                        iconLeft="fa fa-arrow-left"
                    />

                    <Button
                        label="Solicitar Ajuste"
                        variant="indigo"
                        loading={loading}
                        onClick={handleSalvar}
                        iconLeft="fa fa-save"
                    />

                </div>

            </div>

        </div>
    );
}

export default CadastrarAjusteComissao;